module.exports = __webpack_public_path__ + "img/exploreforever.112e853f.png";